
import { questions } from "@/data/questions";
import { AssessmentHeader } from "./AssessmentHeader";
import { AssessmentQuestion } from "../AssessmentQuestion";
import { AssessmentControls } from "./AssessmentControls";
import { useToast } from "@/hooks/use-toast";
import { getDimensionDescription, detailedDimensionDescriptions } from "@/data/questions";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/contexts/AuthContext";

interface AssessmentViewProps {
  currentQuestionIndex: number;
  currentAnswer?: number;
  onAnswer: (value: number) => void;
  onNext: () => void;
  onPrevious: () => void;
  onSkip: () => void;
}

export const AssessmentView = ({
  currentQuestionIndex,
  currentAnswer,
  onAnswer,
  onNext,
  onPrevious,
  onSkip,
}: AssessmentViewProps) => {
  const currentQuestion = questions[currentQuestionIndex];
  const { toast } = useToast();
  const isMobile = useIsMobile();
  const { user } = useAuth();

  const handleNext = () => {
    if (!currentAnswer && currentAnswer !== 0) {
      toast({
        title: "Answer Required",
        description: "Please select an answer before proceeding.",
        variant: "destructive",
      });
      return;
    }
    onNext();
  };

  return (
    <div className="min-h-screen bg-background py-4 sm:py-8 px-3 sm:px-4 md:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <AssessmentHeader 
          currentQuestionIndex={currentQuestionIndex}
          totalQuestions={questions.length}
          currentDimension={currentQuestion.dimension}
        />

        <div className={`transition-all duration-300 ${isMobile ? 'mt-2' : 'mt-4'}`}>
          <AssessmentQuestion
            question={currentQuestion}
            onAnswer={onAnswer}
            currentAnswer={currentAnswer}
          />
        </div>

        <div className={`${isMobile ? 'mt-4' : 'mt-6'}`}>
          <AssessmentControls 
            onPrevious={onPrevious}
            onNext={handleNext}
            onSkip={onSkip}
            isFirstQuestion={currentQuestionIndex === 0}
            isLastQuestion={currentQuestionIndex === questions.length - 1}
            currentAnswerSelected={currentAnswer !== undefined}
          />
        </div>
      </div>
    </div>
  );
};
